<!-- <div
  class="layout-menu-wrapper shadow-3"
  [style]="{ transform: showMenu ? 'translateX(0)' : '' }"
  [ngClass]="{ 'layout-sidebar-active': sidebarActive }"
  style="
    border-right-style: solid;
    border-right-width: 2px;
    
    
  "
  (click)="onSidebarClick($event)"
>
  <div class="layout-menu-content">
  <div
    class="menu-logo"
    *ngIf="!isHorizontal() || isMobile()"
    
  >
    <a class="menu-pin" style="background-color: #2121508c;" (click)="onToggleMenu($event)" [ngStyle]="{ 'margin-left': !sidebarStatic && !pinActive? '0': 'auto' }">
      <svg
        viewBox="0 0 24 24"
        stroke="#cdcdd5"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="h-6 w-6 transform"
        stroke-width="2"
        style="width: 24px !important; height: 24px !important;"
        [ngClass]="{ 'rotate-180': pinActive }"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <line x1="4" y1="6" x2="14" y2="6" />
        <line x1="4" y1="18" x2="14" y2="18" />
        <path d="M4 12h17l-3 -3m0 6l3 -3" />
      </svg>
    </a>
  </div>

  <div class="layout-menu-container" >
    <ul class="layout-menu" *ngIf="!loadingMenu">
      <ng-container *ngFor="let item of model; let i = index">
        <li
          app-menuitem
          *ngIf="!item.expanded"
          [item]="item"
          [index]="i"
          [root]="true"
          [single]="true"
        ></li>
        <li
          app-menuitem
          *ngIf="item.expanded"
          [item]="item"
          [index]="i"
          [root]="true"
          [active]="true"
        ></li>
      </ng-container>
    </ul>
    <div class="layout-menu mt-3">
      <app-social-links [social_networks]="social_networks"></app-social-links>
    </div>
  </div>
  </div>
</div> -->

<p-button
  (click)="showMenu = !showMenu"
  icon="pi pi-bars"
  styleClass="p-button-text p-button-secondary"
  [style]="{ position: 'absolute', top: '12px', left: '24px' }"
></p-button>

<style>
  :host ::ng-deep .custom-spinner .p-progress-spinner-circle {
    animation: custom-progress-spinner-dash 1.5s ease-in-out infinite,
      custom-progress-spinner-color 6s ease-in-out infinite;
  }

  @keyframes custom-progress-spinner-color {
    100%,
    0% {
      stroke: #85838d;
    }
    40% {
      stroke: #85838d;
    }
    66% {
      stroke: #85838d;
    }
    80%,
    90% {
      stroke: #85838d;
    }
  }

  @keyframes custom-progress-spinner-dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35px;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124px;
    }
  }
</style>
